export const VIDEO_GROUP_RATINGS: Record<string, number> = {
  renderforest: 6, // max of Fast 6 / Pro 7.5
  bytePlus: 9.5, // Seedance 2.0
  kling: 9.0, // Kling 3.0 Omni
  google: 9.0, // Veo
  openAi: 7.5, // Sora
  miniMax: 9.0, // MiniMax H3
  pixVerse: 7.0 // max across V6 / C1 / V5
}

export const VIDEO_VARIANT_RATINGS: Record<string, number> = {
  // Renderforest
  'forest-1.0': 6.0, // Fast
  'forest-1.0-pro': 7.5, // Pro

  // Seedance (bytePlus)
  'dreamina-seedance-2.0': 9.5, // Seedance 2.0
  'dreamina-seedance-2.0-fast': 8.5, // Seedance 2.0 Fast
  'dreamina-seedance-2.0-mini': 8.5, // Seedance 2.0 Mini
  'seedance-1.5-pro': 7.5, // Seedance 1.5 pro

  // Kling
  'kling-v3-omni': 9.0, // 3.0 Omni
  'kling-v3-omni-with-sound': 9.0, // 3.0 Omni With Audio
  'kling-v2.6': 8.0, // 2.6

  // Sora
  'sora-2': 7.5,

  // Pixverse
  'pixverse-v6': 7.0,
  'pixverse-c1': 7.0,
  'pixverse-v5': 6.0,

  // Veo
  'veo-3.1-fast': 9.0,

  // MiniMax
  'minimax-h3': 9.0
}
